import axios from "axios";
import { supabase } from "./supabase";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  const accessToken = data?.session?.access_token;
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Force sign-out on invalid/expired Supabase token to avoid stuck sessions.
      // Only touch Supabase if there's actually a Supabase session —
      // Google-cookie users should NOT get kicked out here.
      try {
        const { data } = await supabase.auth.getSession();
        if (data?.session) {
          await supabase.auth.signOut({ scope: "local" });
        }
      } catch (signOutErr) {
        // eslint-disable-next-line no-console
        console.warn(
          "[api] Supabase local sign-out after 401 failed:",
          signOutErr?.message || signOutErr
        );
      }
    }
    return Promise.reject(error);
  }
);

export default api;
